export const VALUES_MAP = {
  OPTIONS: {
    colors: ['color', 'colors'],
    upholsteries: ['upholstery', 'upholsteries'],
    accessories: ['accessory', 'accessories'],
    wheels: ['wheel', 'wheels']
  },
  MODES: {
    details: ['details', 'customise'],
    customise: ['customise', 'details']
  }
};